import { json, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import "./QuotationOrder.css";
import LoadingScreen from "../../component/LoadingScreen";

const CreateQuotation = () => {
  const navigate = useNavigate();
  const [orderDetail, setOrderDetail] = useState({
    orderItemlistByOrderId: [],
    orderFeedbackListByOrderId: [],
    orderApprovalListByOrderId: [],
  });

  let [token, setToken] = useState("");
  const resource = "create-quotation";
  const [internalName, setInternalName] = useState("");
  const [internalEmail, setInternalEmail] = useState("");
  const [quotationOrderDate, setQuotationOrderDate] = useState("");
  const [msaDate, setMsaDate] = useState("");
  const [quotationOtcTotal, setQuotationOtcTotal] = useState(0);
  const [quotationMrcTotal, setQuotationMrcTotal] = useState(0);
  const [error, setError] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFailSubmit, setOpenFailSubmit] = useState(false);
  const [openFailConfirm, setOpenFailConfirm] = useState(false);
  const [openConfirmSucces, setOpenConfirmSucces] = useState(false);
  const [to, setTo] = useState("");
  const [company, setCompany] = useState("");
  const [re, setRe] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [specifiedTc, setSpecifiedTc] = useState("");
  const [quotationNo, setQuotationNo] = useState("");
  const [isDownloadActive, setIsDownloadActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [locale, setLocale] = useState("id-ID");
  const [quotationPriceUSD, setQuotationPriceUSD] = useState("");
  const [quotationPriceIDR, setQuotationPriceIDR] = useState("");
  const [vat, setVat] = useState();

  useEffect(() => {
    const fetchVat = async () => {
      try {
        const key = "XCP_VAT";
        const result = await axios.get(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/configuration/find-by-key?key=${key}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            }
        );

        const responseVat = result.data.find(
          (item) => item.xcp_key === "XCP_VAT"
        )?.xcp_value;

        setVat(responseVat);
      } catch (error) {
        console.error("Error fetching vat:", error);
      }
    };

    fetchVat();
  }, []);

  const handleMrc = (index, value) => {
    // Create a new copy of the order items array
    const updatedOrderItems = [...orderDetail.orderItemlistByOrderId];

    updatedOrderItems[index].quotation_mrc = value;

    // Update the state with the modified order list
    setOrderDetail({
      ...orderDetail,
      orderItemlistByOrderId: updatedOrderItems,
    });

    let quotation_mrc_total = 0;
    orderDetail.orderItemlistByOrderId.forEach((item) => {
      quotation_mrc_total += Number(item.quotation_mrc);
    });
    setQuotationMrcTotal(quotation_mrc_total);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    // Retrieve the token from local storage
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    // Fetch internal data using the token
    const fetchInternalData = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${storedToken}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Failed to fetch internal data");
          throw new Error(data.message || "Failed to fetch internal data");
        }

        setInternalName(data[0].xcp_internal_name);
        setInternalEmail(data[0].xcp_internal_email);
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchInternalData();
  }, []);

  useEffect(() => {
    // Set the current date for the order date field
    const currentDate = new Date().toISOString().split("T")[0];
    setQuotationOrderDate(currentDate);
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("param1");

  useEffect(() => {
    // Fetch internal data using the token
    const fetchFindPrice = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/customer/find-price?orderId=${orderId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Failed to fetch find price");
          throw new Error(data.message || "Failed to fetch find price");
        }

        setQuotationPriceIDR(data[0].quotation_price_idr);
        setQuotationPriceUSD(data[0].quotation_price_usd);
        loadOrderDetail(
          searchParams.get("param1"),
          data[0].quotation_price_usd,
          data[0].quotation_price_idr
        );
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchFindPrice();
  }, []);

  const loadOrderDetail = async (
    xcpOrderId,
    quotationOrderPriceUSD,
    quotationOrderPriceIDR
  ) => {
    try {
      const result = await axios.get(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-detail?param1=${xcpOrderId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            }
      );

      const data = result.data;

      let quotationOrderPrice = null;
      if (data.quotation_currency === "IDR") {
        quotationOrderPrice = quotationOrderPriceIDR;
      } else if (data.quotation_currency === "USD") {
        quotationOrderPrice = quotationOrderPriceUSD;
      }

      let quotation_otc_total = 0;
      let quotation_mrc_total = 0;

      data.orderItemlistByOrderId.forEach((item) => {
        const cable_type_a = item.cable_type_a;
        const a_end_rack_id = item.a_end_rack_id;
        const company_requestor = data.company_requestor;
        const interface_name_a = item.interface_name_a;

        const cable_type_b = item.cable_type_b;
        const b_end_rack_id = item.b_end_rack_id;
        const company_destination = data.company_destination;
        const interface_name_b = item.interface_name_b;

        item.service_description =
          "Location: " +
          data.order_location_name +
          "\nCross Connect using " +
          cable_type_a +
          " :\nFrom: " +
          a_end_rack_id +
          " (" +
          company_requestor +
          ") Interface type " +
          interface_name_a +
          "\n\nCross Connect using " +
          cable_type_b +
          " :\nTo: " +
          b_end_rack_id +
          " (" +
          company_destination +
          ") Interface type " +
          interface_name_b;

        if (item.quotation_otc === null) {
          item.quotation_otc = 0;
        }
        if (item.quotation_mrc === null) {
          item.quotation_mrc = quotationOrderPrice;
        }
        item.quotation_otc_sub_total =
          item.cable_quantity * item.quotation_otc;
        item.quotation_mrc_sub_total =
          item.cable_quantity * item.quotation_mrc;

        quotation_otc_total += item.quotation_otc_sub_total;
        quotation_mrc_total += item.month * item.quotation_mrc_sub_total;
      });
      setQuotationOtcTotal(quotation_otc_total);
      setQuotationMrcTotal(quotation_mrc_total);

      setTo(data.pic_requestor);
      setCompany(data.company_requestor);
      setRe(data.company_requestor + " - " + data.company_destination);
      setQuotationNo(data.quotation_no);
      if (data.quotation_tc_option !== null) {
        setSelectedOption(data.quotation_tc_option);
      }
      if (data.quotation_tc !== null) {
        setSpecifiedTc(data.quotation_tc);
      }
      setOrderDetail(data);
      loadCompanyDetail(data.company_requestor_id, data.quotation_msa_date);
    } catch (error) {
      console.error("Fetch Error Order Detail:", error);
      setError("Fetch Error Order Detail: " + error.message);
    }
  };

  const loadCompanyDetail = async (companyId, quotation_msa_date) => {
    try {
      const result = await axios.get(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/company/company-detail?companyId=${companyId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            }
      );

      const data = result.data;

      if (quotation_msa_date === null) {
        setMsaDate(data[0].quotation_msa_date.split("T")[0]);
      } else if (quotation_msa_date !== null) {
        setMsaDate(quotation_msa_date.split("T")[0]);
      }
    } catch (error) {
      console.error("Fetch Error Company Detail:", error);
      setError("Fetch Error Company Detail: " + error.message);
    }
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();

    const form = event.target.closest("form"); // Get form element
    const isValid = form.checkValidity();

    if (isValid) {
      // Form is valid, proceed with submission or further logic
      const buttonValue = event.target.querySelector(
        '[type="submit"]:focus'
      )?.value;
      if (buttonValue === "confirm") {
        handleConfirm();
      } else if (buttonValue === "submit") {
        setOpenConfirm(true);
      }
    } 
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenFailSubmit(false);
    setOpenConfirmSucces(false);
    setOpenFailConfirm(false);
  };

  function getDateTimeInUserTimeZone(date) {
    const userTimeZone = moment.tz.guess();
    // Get the current time in the user's local time zone
    const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");

    // Combine the selected date with the current time
    const dateTimeInUserTimeZone = moment
      .tz(`${date}T${currentTime}`, userTimeZone)
      .format("YYYY-MM-DDTHH:mm:ss");

    return dateTimeInUserTimeZone;
  }

  const handleSubmit = async (event) => {
    const submitQuotationOrder = {
      order_id: orderId,
      email_requestor: internalEmail,
      quotation_date: getDateTimeInUserTimeZone(quotationOrderDate),
    };

    try {
      const response = await fetch(
        "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/order/submit-quotation",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
          body: JSON.stringify(submitQuotationOrder),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);

      if (!response.ok) {
        throw new Error("Failed to submit quotation order");
      }

      const { message } = responseBody;
      if (message == "success") {
        // Store the token in local storage
        localStorage.setItem("token", token);

        setOpenConfirm(false);
        setOpenSuccess(true);
      } else {
        setOpenConfirm(false);
        setOpenFailSubmit(true);
      }
    } catch (error) {
      setError("Submission Error: " + error.message);
      console.error("Submission Error:", error.message);
      setOpenConfirm(false);
      setOpenFailSubmit(true);
    }
  };

  const handleConfirm = async (event) => {
    setIsLoading(true);

    const inputQuotationOrder = {
      order_id: orderId,
      customer_name: to,
      company_name: company,
      recipient: re,
      msa_date: getDateTimeInUserTimeZone(msaDate),
      quotation_date: getDateTimeInUserTimeZone(quotationOrderDate),
      quotation_no: quotationNo,
      quotation_prepare_by: internalName,
      quotation_tc_option: selectedOption,
      quotation_tc: specifiedTc,
      quotation_currency: selectedCurrency,
      orderItemlist: [],
      quotation_otc_total: quotationOtcTotal,
      quotation_mrc_total: quotationMrcTotal,
    };

    orderDetail.orderItemlistByOrderId.forEach((item) => {
      inputQuotationOrder.orderItemlist.push({
        item_id: item.item_id,
        service_description: item.service_description,
        quantity: item.cable_quantity,
        month: item.month,
        quotation_otc: item.quotation_otc,
        quotation_mrc: item.quotation_mrc,
        quotation_otc_sub_total: item.quotation_otc_sub_total,
        quotation_mrc_sub_total: item.quotation_mrc_sub_total,
      });
    });

    try {
      const response = await fetch(
        "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/order/confirm-quotation",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
          body: JSON.stringify(inputQuotationOrder),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);

      if (!response.ok) {
        throw new Error("Failed to confirm quotation order");
      }

      const { message } = responseBody;
      const { downloadUrl } = responseBody;
      const { fileName } = responseBody;
      if (message == "success") {
        setIsDownloadActive(true);
        setOpenConfirmSucces(true);
        setDownloadUrl(downloadUrl);
        setFileName(fileName);
      } else {
        setOpenFailConfirm(true);
      }
    } catch (error) {
      setError("Submission Error: " + error.message);
      console.error("Submission Error:", error.message);
      setOpenFailConfirm(true);
    } finally {
      setIsLoading(false);
    }
  };

  function inputSuccess() {
    navigate("/order-list");
  }

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  let tcText = `1. This Order Form is executed by and between ${company} (“Customer”) and PT. NTT Indonesia (“Provider”), and incorporates and is governed by the Master Co-location Service Agreement between ${company} and PT NTT Indonesia with effect from ${formatDate(
    msaDate
  )} (the "MSA").
2. Above price excludes ${vat}% VAT and shall be payable to NTT upon the issuance of the invoice via bank transfer.
3. Minimum contract for cross-connection is 1 year.
4. Early termination will be charged 100% of the remaining contract value.
5. Delivery time: 7-10 days after the order is received.
`;

  const handleOptionChange = (event) => {
    const { value } = event.target;
    setSelectedOption(value);

    // Update the textarea content based on the selected radio button
    if (value === "GENERAL") {
      setSpecifiedTc(tcText);
    } else if (value === "SPECIFIED") {
      setSpecifiedTc(""); // Clear the textarea for the "specified" option
    }
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(downloadUrl, {
        method: "GET", // Use GET to download the file
      });

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up after download
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    currencySelected(orderDetail.quotation_currency);
  }, [orderDetail]);

  function currencySelected(currency) {
    if (currency === "IDR") {
      setSelectedCurrency("IDR");
    } else if (currency === "USD") {
      setSelectedCurrency("USD");
    }
  }

  const handleCurrencyChange = (event, currency) => {
    setSelectedCurrency(currency);

    let quotationOrderPrice = null;
    if (currency === "IDR") {
      quotationOrderPrice = quotationPriceIDR;
      orderDetail.quotation_currency = "IDR";
    } else if (currency === "USD") {
      quotationOrderPrice = quotationPriceUSD;
      orderDetail.quotation_currency = "USD";
    }
    let quotation_otc_total = 0;
    let quotation_mrc_total = 0;

    orderDetail.orderItemlistByOrderId.forEach((item) => {
      item.quotation_otc = 0;
      item.quotation_otc_sub_total = 0;

      item.quotation_mrc = quotationOrderPrice;
      item.quotation_mrc_sub_total = item.cable_quantity * item.quotation_mrc

      quotation_otc_total += item.quotation_otc_sub_total;
      quotation_mrc_total += item.quotation_mrc_sub_total;
    });
    setQuotationOtcTotal(quotation_otc_total);
    setQuotationMrcTotal(quotation_mrc_total);
  };

  //subtotal
  const 
handleUnitPriceOTC = (index, value) => {
    // Create a new copy of the order items array
    const updatedOrderItems = [...orderDetail.orderItemlistByOrderId];

    // Update the month value for the specific order
    updatedOrderItems[index].quotation_otc = value;
    updatedOrderItems[index].quotation_otc_sub_total =
      updatedOrderItems[index].cable_quantity * value;

    // Update the state with the modified order list
    setOrderDetail({
      ...orderDetail,
      orderItemlistByOrderId: updatedOrderItems,
    });

    let quotation_otc_total = 0;
    orderDetail.orderItemlistByOrderId.forEach((item) => {
      quotation_otc_total += item.quotation_otc_sub_total;
    });
    setQuotationOtcTotal(quotation_otc_total);
  };

  const handleUnitPriceMRC = (index, value) => {
    // Create a new copy of the order items array
    const updatedOrderItems = [...orderDetail.orderItemlistByOrderId];

    // Update the month value for the specific order
    updatedOrderItems[index].quotation_mrc = value;
    updatedOrderItems[index].quotation_mrc_sub_total =
      updatedOrderItems[index].cable_quantity * value;

    // Update the state with the modified order list
    setOrderDetail({
      ...orderDetail,
      orderItemlistByOrderId: updatedOrderItems,
    });

    let quotation_mrc_total = 0;
    orderDetail.orderItemlistByOrderId.forEach((item) => {
      quotation_mrc_total += item.month * item.quotation_mrc_sub_total;
    });
      setQuotationMrcTotal(quotation_mrc_total);
  };

  return (
    <div className="container-order-input">
      {isLoading && <LoadingScreen />}
      <Dialog open={openConfirm}>
        <DialogTitle>
          {"Are you sure you want to submit this quotation order?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Clicking "Yes" will submit this quotation order.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openSuccess}>
        <DialogTitle>{"Order Form submitted successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={inputSuccess} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openFailSubmit}>
        <DialogTitle>{"Order Form submitted Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openFailConfirm}>
        <DialogTitle>{"Confirm Quotation Form  Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmSucces}>
        <DialogTitle>{"Confirm Quotation Form successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <h1 className="main-title">Cross Connect Quotation Form</h1>
      <form onSubmit={handleConfirmation}>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Quotation Order Header</h5>
            </div>
            <div className="textbox-gray">
              <label>To</label>
              <input type="text" id="to" value={to} required disabled />
            </div>
            <div className="textbox-gray">
              <label>Company</label>
              <input
                type="text"
                id="company"
                value={company}
                required
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label>Re</label>
              <input type="text" id="re" value={re} required disabled />
            </div>

            <div className="textbox">
              <label>MSA Date</label>
              <input
                type="date"
                value={msaDate}
                onChange={(e) => setMsaDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="orderDate">Date</label>
              <input
                type="date"
                value={quotationOrderDate}
                onChange={(e) => setQuotationOrderDate(e.target.value)}
                required
                disabled
              />
            </div>
            <div className="textbox">
              <label>Quotation No</label>
              <input
                type="text"
                value={quotationNo}
                onChange={(e) => setQuotationNo(e.target.value)}
                required
              />
            </div>
            <div className="textbox-gray">
              <label>Prepared By</label>
              <input type="text" value={internalName} disabled />
            </div>
            <div className="radio-button">
              <label>Quotation Currency</label>
              <div>
                <input
                  type="radio"
                  name="connect"
                  id="connect-one"
                  checked={selectedCurrency === "IDR"}
                  onChange={(event) => handleCurrencyChange(event, "IDR")}
                  enabled
                  required
                />
                <label>IDR</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="connect"
                  id="connect-two"
                  checked={selectedCurrency === "USD"}
                  onChange={(event) => handleCurrencyChange(event, "USD")}
                  enabled
                  required
                />
                <label>USD</label>
              </div>
            </div>
          </div>
        </div>

        {orderDetail.orderItemlistByOrderId &&
          orderDetail.orderItemlistByOrderId.length > 0 &&
          orderDetail.orderItemlistByOrderId.map((order, index) => (
            <div className="box-two-part">
              <div className="requestor-information">
                <div className="title-order-input">
                  <h5>Cross Connect Service ({index + 1})</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="officeAddress">Item Description</label>
                  <textarea
                    style={{
                      backgroundColor: "lightgrey",
                      color: "black",
                      height: "190px",
                    }}
                    disabled
                    value={order.service_description}
                  ></textarea>
                </div>

                <div className="textbox-gray">
                  <label htmlFor="companyName">Month</label>
                  <input
                    type="number"
                    value={order.month}
                    disabled 
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName">Quantity</label>
                  <input type="number" value={order.cable_quantity} disabled />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="companyName">Unit</label>
                  <input
                    type="text"
                    value={order.unit}
                    disabled 
                  />
                </div>
              </div>

              <div className="destination-information">
                <div className="title-order-input">
                  <h5 style={{ visibility: "hidden" }}>.</h5>
                </div>
                <label htmlFor="nrc" style={{ fontSize: "18px" }}>
                  OTC Charging Scheme
                </label>
                <div className="textbox">
                  <label htmlFor="nrc">Unit Price ({selectedCurrency})</label>
                  <input
                    type="number"
                    value={order.quotation_otc}
                    onChange={(e) => 
handleUnitPriceOTC(index, e.target.value)}
                    required
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName">Subtotal ({selectedCurrency})</label>
                  <input
                    type="text"
                    value={new Intl.NumberFormat(locale, {
                      useGrouping: true,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 9,
                    }).format(order.quotation_otc_sub_total)}
                    required
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </div>

                <div className="title-order-input"></div>
                <label htmlFor="picName" style={{ fontSize: "18px" }}>
                  MRC Charging Scheme
                </label>
                <div className="textbox">
                  <label htmlFor="picName">
                    Unit Price ({selectedCurrency})
                  </label>
                  <input
                    type="number"
                    value={order.quotation_mrc}
                    onChange={(e) => handleUnitPriceMRC(index, e.target.value)}
                    required
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName1">
                    Subtotal ({selectedCurrency})
                  </label>
                  <input
                    type="text"
                    value={new Intl.NumberFormat(locale, {
                      useGrouping: true,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 9,
                    }).format(order.quotation_mrc_sub_total)}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>
            </div>
          ))}

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Agreement Details</h5>
            </div>
            <div className="radio-button">
              <label>Terms & Conditions</label>
              <div>
                <input
                  type="radio"
                  name="tc"
                  id="general-tc"
                  value="GENERAL"
                  onChange={handleOptionChange}
                  checked={selectedOption === "GENERAL"}
                  disabled={!msaDate} // Disable if msaDate is empty
                  required
                />
                <label htmlFor="general-tc">
                  Use general terms & conditions
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="tc"
                  id="specified-tc"
                  value="SPECIFIED"
                  onChange={handleOptionChange}
                  checked={selectedOption === "SPECIFIED"}
                  disabled={!msaDate} // Disable if msaDate is empty
                />
                <label htmlFor="specified-tc">Specified T&C</label>
              </div>
              <textarea
                placeholder={
                  selectedOption === "SPECIFIED"
                    ? "Enter specified terms & conditions"
                    : ""
                }
                value={specifiedTc}
                onChange={(e) => setSpecifiedTc(e.target.value)}
                style={{
                  width: "100%",
                  marginTop: "8px",
                  padding: "8px",
                  height: "400px",
                }}
                disabled={!msaDate} // Disable if msaDate is empty
                required
              />
              {!msaDate && (
                <p style={{ color: "red", marginTop: "10px" }}>
                  Please enter the MSA Date before selecting the terms &
                  conditions.
                </p>
              )}
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
          </div>
        </div>

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Total Project Value</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">
                Total OTC Price ({selectedCurrency})
              </label>
              <input
                type="text"
                value={new Intl.NumberFormat(locale, {
                  useGrouping: true,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 9,
                }).format(quotationOtcTotal)}
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">
                Total MRC Price ({selectedCurrency})
              </label>
              <input
                type="text"
                value={new Intl.NumberFormat(locale, {
                  useGrouping: true,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 9,
                }).format(quotationMrcTotal)}
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
            <div className="button-group">
              <button
                className="btn-confirm"
                type="submit"
                name="action"
                value="confirm"
              >
                Confirm
              </button>

              {/* Conditionally render the download button */}
              {isDownloadActive && (
                <button
                  className="btn-download"
                  type="button"
                  onClick={handleDownload}
                >
                  Download
                </button>
              )}
              {isDownloadActive && (
                <button
                  className="btn-submit"
                  type="submit"
                  name="action"
                  value="submit"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateQuotation;
